<template>
    <div class="atlas">  
        <h2>文献大数据平台知识图谱自动抽取系统</h2>
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px">
            <el-form-item label="抽取方式："  prop="method">
                <el-radio-group v-model="ruleForm.method">
                    <el-radio label="llm">大模型</el-radio>
                    <el-radio label="rule">神经网络模型</el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item label="抽取内容："  prop="text">
                <el-input type='textarea' v-model="ruleForm.text" :rows="6"  :cols="4"  class="problem"  placeholder="请输入待构建知识图谱的原始文本内容，并选择您希望的构建方式，最后点击“开始抽取”按钮以启动知识抽取流程。"  ></el-input>
            </el-form-item>
            <el-form-item label=""  >
                <el-button  type="primary"   @click="begin_click" :loading='isBegin'>开始抽取</el-button>
            </el-form-item>
        </el-form>  
        <div class="atlas-cont" v-if='isShowGrap' v-loading='isBegin'> 
            <div id="container" ref="complex" class="complex-d3DIV"></div>

            <div class="cont-btn">   
                <el-button  type="primary" plain  @click="save_pic">保存图片</el-button>
                 <el-button  type="success"   @click="derive">导出</el-button>
            </div>
            <div class="atlas-list">
                <el-table
                    :data='tableList'
                    @sort-change="sort_change"
                    :header-cell-style="{background:'#396de7',color:'#fff'}"
                    size='mini'
                    row-key="id"
                    border
                    default-expand-all>
                    <el-table-column
                        sortable
                        label="NO"
                        align="center"
                        prop="num"
                        width='140'
                    >
                        <template slot-scope="scope">
                            <span >{{scope.$index+1}}</span>  
                        </template>
                    </el-table-column>
                    <el-table-column
                        align="center"
                        prop="startNode"
                        sortable
                        label="节点名称">
                    </el-table-column>
                    <el-table-column
                        align="center"
                        prop="endNode"
                        sortable
                        label="节点名称">
                    </el-table-column>
                    <el-table-column
                        align="center"
                        prop="relation" 
                        label="关系">
                    </el-table-column>
                </el-table> 
                <el-pagination 
                    size='small'
                    class="page-wrap"  
                    @current-change="changePage" 
                    @size-change="sizeChange"
                    background
                    :current-page="pageInfo.pageNum" 
                    :page-count="pageInfo.pageTotal" 
                    :page-size="pageInfo.pageSize"
                    :page-sizes="[10, 20, 30, 50, 100]"
                    :total="pageInfo.total"
                    layout="total, sizes, prev, pager, next, jumper" >
                </el-pagination>
            </div>
        </div>  
    </div>
</template>

<script>
// 模拟数据 
// import subjectData from './subjectData.js' 
// import subjectJson from './subjectJson.js' 

import Json from './json.js' 
import G6 from '@antv/g6'; 
import { knowledgeGraph,knowledgeGraphExport,knowledgeGraphPage } from '../../io/api.js'
export default {
    components: { 
    },
    data () {
        return { 
            ruleForm:{
                method:"rule",
                text:'',//张某某,女,14岁,学生,1983年5月6日初诊。患者1年前月经初潮,近3个月每逢经前1～2天出现鼻衄,血量较多,同时出现乳房胀痛,心烦急燥易怒,头痛,纳呆,腰腹疼痛,二便正常。望之患者体瘦,面色无华,舌苔薄黄,脉弦数。姚老认为此属肾阴不足,水不涵木,虚火上炎,迫血妄行所致之逆经,治以滋阴清热、柔肝止血之法。处方:细生地12g,杭白芍9g,粉丹皮9g,干百合9g,白茅根12g,杭菊花9g,青竹茹12g,大小蓟各24g,川牛膝9g。水煎服。患者服药4剂后鼻衄愈。访3个月无复
            },
            rules: {
                method:[
                    { required: true, message: '请选择抽取方式', trigger: 'change' }
                ],
                text: [
                    { required: true, message: '请输入您要抽取的内容', trigger: 'blur' }, 
                ],
            },  
            textId:'',
            labelPosition:'center', //center:居中,top:上方,left:左边,right:右边 
            sideLabel:'hidden',     
            graph: null,//初始化
            graphWidth:'',
            graphHeight:'',
            newData:[], 

            isBegin:false,
            isShowGrap:false,
            graphList:{},   
            tableList:[],
            isNodata:false, 
            pageInfo: {
                pageNum: 1,
                pageTotal: 1,
                total: 1,
                pageSize: 10,
            }, 

        }
    },
    watch: { 
        
    },
    mounted () { 
    },
    methods: { 
        initData(){  
            this.tableList=[];  
            this.isNodata=false;
            this.pageInfo= {
                pageNum: 1,
                pageTotal: 1,
                total: 1,
                pageSize: 10,
            }; 
        },
        begin_click(){
            this.initData();
            this.isBegin=true;
            knowledgeGraph(this.ruleForm).then(res=>{
                let data =res.data;
                if(data.status=="success"){
                    this.isShowGrap=true;
                    this.graphList=data.data||[];
                    this.textId=data.textId||'';
                    if(this.textId){
                        this.getTable()
                    }
                    this.$nextTick(()=>{
                        this.data_process();
                    })
                    console.log(this.graphList)
                } else{
                    this.$message.error( data.message||'抽取请求失败～')
                }
                this.isBegin=false;
            }) 
        },
        getTable(){
            let params={
                limit:this.pageInfo.pageSize,
                page:this.pageInfo.pageNum,
                textId:this.textId
            }
            knowledgeGraphPage(params).then(res=>{
                let data=res.data;
                if(data.code==0){
                    this.tableList=data.data.list||[];
                    this.pageInfo.total=data.data.total||1;
                }else{
                    this.$message.error( data.msg||'抽取请求失败～')
                }
            })
        },
        //数据处理
        data_process(){ 
            let nodesData=this.graphList &&this.graphList.nodes||[];
            let edgesData=this.graphList &&this.graphList.edges||[]; 
            if(nodesData.length==0){
                this.isNodata = true
                return
            }
            this.newData={
                nodes:[],
                edges:[],
            }
            nodesData&&nodesData.forEach((item,index)=>{ 
                // item.label=item.name;
                this.$set(item,'num',index+1)
                this.newData.nodes.push(item)
            }) 
            edgesData&&edgesData.forEach((item,index)=>{

                // item.label=item.weight;
                this.$set(item,'num',index+1)
                this.newData.edges.push(item)
                
            })  
            this.changePage(1)  
            this.graph_init()

        },
        //图谱相关设置
        graph_init(){ 
            let container = document.getElementById('container');
            if (container) {
                this.graphWidth = container.clientWidth;
                this.graphHeight = container.clientHeight;
                this.set_nodeStyle(); 
                this.graph_tab('force',2);
            }
        }, 
        //初始化图谱
        set_nodeStyle(){
            let _this = this;
            //初始化的节点颜色处理 
            this.newData&&this.newData.nodes.forEach(function (node) { 
                if (!node.style) {
                    node.style = {};
                }
                //设置节点颜色
                _this.node_fill(node) 
                //根据degree，设置节点大小 
                // if(node.degree>Number(_this.degreeNum)){
                //     node.size = 40; 
                // }else{
                //     node.size = 20; 
                // }
            });
        },
        //节点的颜色
        node_fill(node,type){
            //degree   
            let color="#ff9898";  
            if (node.degree=='中医治则') {
                color='#fca3d9'
            } else if(node.degree=='中医治疗'){
                color='#e84dff'
            } else if(node.degree=='中医疾病'){
                color='#c147fa'
            } else if(node.degree=='中医证候'){
                color='#9a80ff'
            } else if(node.degree=='中医诊断'){
                color='#c0c8fd'
            } else if(node.degree=='中药'){
                color='#fdcece'
            }else if(node.degree=='临床表现'){
                color='#3ba7fa'
            } else if(node.degree=='体格检查'){
                color='#60f6fc'
            } else if(node.degree=='方剂'){
                color='#78cea3'
            } else if(node.degree=='治法'){
                color='#96fe82'
            }else if(node.degree=='症状'){
                color='#dafe5c'
            } else if(node.degree=='穴位'){
                color='#fbbd37'
            } else if(node.degree=='西医治疗'){
                color='#fd9526'
            } else if(node.degree=='西医疾病'){
                color='#ff6035'
            }else if(node.degree=='辅助检查'){
                color='#bffaee'
            }
            node.style.fill = color
            node.style.stroke = color
        },
        //图谱渲染
        graph_tab(val){  
            if (this.graph) this.graph.destroy(); 
            this.graph = new G6.Graph({
                container: 'container',
                width:this.graphWidth,
                height:this.graphHeight, 
                modes: {
                    default: ['zoom-canvas','click-select','drag-canvas', 'drag-node','activate-relations','collapse-expand-combo'],
                },
                layout: {
                    type: 'force', 
                    preventOverlap: true,
                    linkDistance:150,
                },  
                animate: true,
                //节点在默认状态下的样式属性
                defaultNode: { 
                    size:40,
                    // 节点文字
                    labelCfg: { 
                        position:this.labelPosition,
                        style:{
                            fontSize:14,
                            // stroke:'#000',
                            lineWidth: 2,
                            fill:'#000',
                        }
                    },
                },  
                nodeStateStyles: {
                    // 无关联的节点置灰
                    inactive: {
                        stroke: '#eee',
                        // lineWidth: 2,
                        opacity:.5,
                        'text-shape': {
                            fill: "#eee",
                            stroke: "#eee",
                        },
                    },
                },
                // 设置边高亮样式
                edgeStateStyles: {
                    highlight: {
                        // fill:'#A5E4F0',
                        // stroke: '#A5E4F0', // 这个颜色可以根据个人喜好进行修改
                        lineWidth:8,//lineWidth?lineWidth:4
                        opacity:1
                    },
                    inactive: {
                        stroke: '#eee',
                        fill: "#eee", 
                        'text-shape': {
                            opacity:0.01 
                        },
                    },
                },
                comboStateStyles: {
                    highlight: { 
                        opacity: 0.7,
                        cursor: "pointer",
                        'text-shape': { 
                            lineWidth: 4,
                        },
                    },
                    inactive: {
                        stroke: '#eee',
                        opacity:1,  
                        lineWidth: 4,
                        'text-shape': {
                            fill: "#eee",
                            stroke: "#eee",
                        },
                    },
                },

                //边在默认状态下的样式属性
                defaultEdge: {
                    labelCfg:{
                        style:{
                            opacity:0,
                            fontSize:16,
                            // fill:'#000',
                        }
                    },
                    style:{
                        opacity:.5, 
                        stroke:'#626161',//边的颜色
                        endArrow: { // 设置终点箭头
                            path: '', // 使用内置箭头路径函数，参数为箭头的 宽度、长度、偏移量（默认为 0，与 d 对应）
                            stroke:'#626161 ',
                            fill:'#626161 ', 
                        },
                    },
                    
                    // shape: 'arc',  // 在数据中已经指定 shape，这里无需再次指定
                    curveOffset: -80,
                },
            }); 
            this.graph.data(this.newData);
            this.graph.render();   
            // this.graph.zoomTo(0.8,  );
            //边的移入移出
            this.graph.on("edge:mouseenter", (e) => {  
                this.graph.setItemState(e.item, "highlight", true);
                this.edgesOpacity(e.item,1,'hover' )   
            });
            this.graph.on("edge:mouseleave", (e) => { 
                this.graph.setItemState(e.item, "highlight", false);
                this.edgesOpacity(e.item,0 ) 
                
            });  
            this.graph.on('node:mouseenter', this.graph_mouseenter)
            this.graph.on('node:mouseleave', this.graph_mouseleave) 
        }, 
        //鼠标移入时，设置节点连线高亮
        graph_mouseenter(e){
            let that = this // 改变this指向
            let item = e.item; 
            // 设置是否在更新/删除后自动重绘，一般搭配 paint() 方法使用。
            that.graph.setAutoPaint(false) 
            that.graph.getEdges().forEach(function (edge) { 
                //全部边文字显示
                that.edgesOpacity(edge,1 ,'hover' )    
                //getSource()获取当前边的起始节点。 getTarget获取当前边的终止节点。
                if (edge.getSource() != item && edge.getTarget() != item) {
                    that.edgesOpacity(edge,0,'hover')
                } 
            })
            that.graph.paint()
            that.graph.setAutoPaint(true)
        },
        //清除节点连线高亮状态
        graph_mouseleave () {
            const that = this
            this.graph.setAutoPaint(false)
            //边文字不显示
            this.graph.getEdges().forEach(function (edge) { 

                that.edgesOpacity(edge,0,)
            })
 
            this.graph.paint()
            this.graph.setAutoPaint(true)
        },
        //边laberl的文字透明度
        edgesOpacity(edge,num,type){
            let opacity = num;   
            if(this.sideLabel=='show'){
                opacity=0.5;
                if(type=='hover'){
                    opacity=1
                }
            }else{
                opacity=num;
            }
            this.graph.updateItem(edge, {
                labelCfg: {
                    style: {  
                        opacity,
                    }, 
                }
            }) 
        }, 
        save_pic(){
            window.oldRatio = window.devicePixelRatio
            window.devicePixelRatio = 4
            this.graph.downloadFullImage("复杂网络分析结果图", 'image/png', {padding:20})
            setTimeout(() => {
                window.devicePixelRatio = window.oldRatio
            }, 100) 
        }, 
        derive(){
            let strUrl =  `https://www.tcmkb.cn/tcmkb-api/knowledge_graph_relation/export?textId=${this.textId}`;
            window.open(strUrl); 
            //下载乱码
            // exportExcelByIds({baseId:this.storeId,ids,responseType: 'blob'}).then(res=>{
            //     fileDownload(res.data, '医案.xls')
            // })
        },
        changePage(num) { 
            this.pageInfo.pageNum = num;  
            this.getTable()
        }, 
        sort_change(column) { // column是个形参，具体查看element-ui文档
            this.column = column; 
            this.changePage(1);

        }, 
        sizeChange(val){ 
            this.pageInfo.pageSize=val; 
            this.changePage(1)
        }, 
    }
}
</script> 
<style lang="less" scoped> 
.atlas{
    width: 1200px;
    margin: 40px auto; 
    padding-bottom: 40px; 
    ::v-deep .el-textarea__inner {  
        resize: none;  
    } 
    .cont-btn{
        text-align: right;
        margin-bottom: 10px;
    }
}   
#container{
    border:1px dashed #396de7;
    width: 100%;
    height: 750px;
    margin-bottom: 20px;
} 
</style>